export const Operators = {
    '=': 'gelijk is aan',
    '>': 'groter is dan',
    '<': 'kleiner is dan',
    '<>': 'niet gelijk is aan',
    'in': 'onderdeel uitmaakt van'
};

export const Data = {
    relations: {
        address: {
            display_name: 'Adres',
            available_fields: [
                'address_type',
                'house_no',
                'house_no_extra',
                'street',
                'zipcode',
                'city',
            ],
            available_operators: ['=', '<>', 'in'],
        },

        total_price:
        {
            display_name: 'Totaalbedrag',
            available_fields: [],
            available_operators: ['=', '<>', '<', '>'],
            special_relation: true,
        },

        hours_between_same_order: {
            display_name: 'Uren tussen dezelfde order',
            available_fields: [],
            available_operators: Object.keys(Operators),
            special_relation: true,
        },

        sales_order_lines: {
            display_name: 'Producten in de order',
            available_fields: [
                'quantity',
                'product_identifier',
            ],
            available_operators: ['=', '<>', '<', '>'],
            special_relation: true,
        },

        different_billing_and_shippping_address: {
            display_name: 'Verschillende factuur- en verzendadres',
            available_fields: [],
            available_operators: [],
            special_relation: true,
        },

        sales_order: {
            display_name: 'Order',
            available_fields: [
                'payment_method_brand',
                'company_name',
                'grand_total',
            ],
            available_operators: ['=', '<>', 'in'],
        },

        dispatch_request: {
            display_name: 'Dispatch request',
            available_fields: [
                'carrier_id',
                'carrier_method_id',
                'dispatch_date',
                'dispatch_type_id',
                'status',
            ],
            available_operators: Object.keys(Operators),
        },
    },
};

export const Fields = {
    'null': 'Geen',
    'email': 'E-mailadres',
    'zipcode': 'Postcode',
    'house_no': 'Huisnummer',
    'address_type': 'Soort adres',
    'house_no_extra': 'Huisnummer toevoeging',
    'street': 'Straatnaam',
    'city': 'Plaatsnaam',
    'phone_number': 'Telefoonnummer',
    'quantity': 'Aantal',
    'payment_method_brand': 'Betaalwijze',
    'company_name': 'Bedrijfsnaam',
    'grand_total': 'Totaalbedrag',
    'carrier_id': 'Carrier ID',
    'carrier_method_id':  'Carrier method ID',
    'dispatch_type_id': 'Dispatch type ID',
    'status': 'Status',
    'dispatch_date': 'Dispatch datum',
};

export const Relations = {
    ...Object.keys(Data.relations).reduce((acc, key) => {
        acc[key] = Data.relations[key].display_name;
        return acc;
    }, {}),
};

export const SpecialRelations = {
    ...Object.keys(Data.relations).reduce((acc, key) => {
        if (Data.relations[key].special_relation) {
            acc[key] = Data.relations[key].display_name;
        }
        return acc;
    }, {})
};

export const RelationIsSpecial = (relation) => {
    return Object.hasOwnProperty.call(SpecialRelations, relation);
};

export const GetAvailableFields = (relation) => {
    return Data.relations[relation].available_fields.reduce((acc, field) => {
        acc[field] = Fields[field];
        return acc;
    }
    , {});
};

export const GetAvailableOperators = (relation) => {
    return Data.relations[relation].available_operators.reduce((acc, operator) => {
        acc[operator] = Operators[operator];
        return acc;
    }
    , {});
};

export const ValueFormatter = ({operator, value}) => {
    switch (operator) {
        case 'in':
            return value.split(',').join(', ').replace(/,(?=[^,]*$)/, ' of');
        default:
            return value;
    }
};

export default Data;